import React, { useState, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';

function Achievements() {
  // 1. R2 / Backend se naye dynamic achievements load karna
  const [dynamicAchievements, setDynamicAchievements] = useState([]);

  useEffect(() => {
    fetch(`/data_achievements.json?t=${Date.now()}`)
      .then((res) => (res.ok ? res.json() : []))
      .then((json) => {
        if (Array.isArray(json)) setDynamicAchievements(json);
      })
      .catch((err) => console.log('Error loading achievements:', err));
  }, []);

  return (
    <div>
      <div className="ibdp-hero-sec">
        <img src="newimg/Screenshot_24.webp" alt="Achievements Banner" />
      </div>

      <div className="achievements-sec">
        <div className="cam-lower-sec">
          <h1 className="title">Achievements</h1>
        </div>

        <div className="achievements-inner-row">
          <div className="achivements-row">
            
            {/* 👉 2. Admin Dashboard (Cloudflare R2) se aane wale naye Dynamic Cards */}
            {dynamicAchievements.map((item) => (
              <div key={item.id} className="achivement-box">
                <div className="achivement-img">
                  {item.images && item.images[0] && (
                    <Link to={item.images[0]} target="_blank" rel="noopener noreferrer">
                      <LazyLoadImage
                        src={item.images[0]}
                        alt={item.title || 'Achievement'}
                      />
                    </Link>
                  )}
                </div>
                <div className="achivement-content">
                  {item.title && item.title !== '.' && (
                    <h3 style={{ fontSize: '15px', color: '#681320', margin: '0 0 6px 0', fontWeight: '700' }}>
                      {item.title}
                    </h3>
                  )}
                  <p style={{ whiteSpace: 'pre-line' }}>
                    {item.description}
                  </p>
                </div>
              </div>
            ))}

   
  
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Aaryaman.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A century to remember, a performance to celebrate!
Congratulations, Aaryaman, on your commendable performance! Wishing you continued success and the very best for the many milestones that lie ahead. 🏏🌟</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Stellar Performance.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A Stellar Performance on the State Stage! ✨🏓

Sanskar School proudly applauds Radhika Soni (XE) for her exceptional achievement at the Table Tennis State Ranking Tournament 2026.

🥇 U-17 Gold Medal & Cash Prize of ₹4000
🥈 U-19 Silver Medal & Cash Prize of ₹2500
🥈 Women’s Singles Silver Medal & Cash Prize of ₹3000
🥈 Women’s Doubles Silver Medal & Cash Prize of ₹1000
🌟👏</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Young Champions.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Young Champions Making Their Mark! 🥇🏓

Sanskar School proudly celebrates the remarkable achievement of Daksh Soni (VI) and Dev Soni (VI) at the Table Tennis State Ranking Tournament 2026 held in Ajmer.</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Priyakshi Kaura.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>From imagination to achievement — congratulations to Priyakshi Kaura on securing AIR 114 in NID 2026 (General Category)! ✨
Your dedication and creative spirit have made the entire Sanskar family proud. Wishing you a future filled with innovation, success, and endless possibilities ahead. 🌟</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Group Dance Competition.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Proud Moment for Sanskar School!

Our talented students brought home the 2nd Runner-Up position at the Interschool Group Dance Competition with their incredible energy, coordination, and performance spirit.

Heartiest congratulations to the team for showcasing outstanding talent and teamwork! 🌟</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Art Battle Season 6.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Proud Moments at Art Battle Season 6 – India Edition! ✨🎨

Our talented young artists showcased their creativity and passion at the Jaipur City Round of Art Battle Season 6, organized by the Kiran Nadar Museum of Art at Dharav High School, Jaipur. Competing among 25–30 schools from across the city, our students impressed everyone with their imagination and artistic excellence. 🖌️🌟

A special congratulations to:
🏆 Genie Kumawat (XI C) – 1st Position & ₹11,000 Voucher
🥉 Yashi Singh (VII A) – 3rd Position & ₹5,000 Voucher

We are incredibly proud of all 36 participants for representing the school with confidence, creativity, and enthusiasm. Keep creating, keep inspiring! 💫🎭</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/INDIA BUILDS.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>CeleWINNERS AT INDIA BUILDS 2026! 🏆🚀

Sanskar School’s Team Tejas has taken the national stage by storm! Outshining competitors at the prestigious entrepreneurship summit organized by Gurukkul & Master’s Union, our students secured:

🥇 1st Place
💰 ₹50,000 Equity-Free Grant

A huge round of applause for Veni Madhav Singh Naruka, Namah Sharma, and Purvi Rajpurohit. Their business vision and impactful presentation earned rave reviews from top-tier investors.

We are incredibly proud of their journey from students to budding entrepreneurs! 🌟👏</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Taekwondo championg cls-5.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Proud moment for Sanskar School! 🥋🏅
Our young Taekwondo champions shine at the 5th Hind India Open Taekwondo Championship with outstanding Gold & Silver medal victories. 🌟</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Adit-Vijai-Asthana.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Huge congratulations to Adit Vijai Asthana for his outstanding performance at the Multi-Subject Quiz National Competition! 🎉 Sanskar is incredibly proud as he advances to the International Level of the Indian Academic Championship (INDAC) -Asian Championship, representing Sanskar school on the world stage! 🌟 INDAC ProudSchool.</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/French-Poem-Recitation.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Proud moment for Sanskar School as our young learners shine on an international stage!
Adhvik Gupta (Grade 6) and Kavish Mathur (Grade 5) brought laurels by securing 1st and 3rd positions in the French Poem Recitation competition organized by l’AMOPA-Loire, France. </p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Kavya-Yadav-Taekwondo.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A proud moment for Sanskar School! ✨
Kavya Yadav of Class X-B shines with a remarkable double victory in karate, securing top honours across two प्रतिष्ठित championships in Jaipur. Her dedication, strength, and fighting spirit truly set her apart.
Congratulations, Kavya! 🥋🏆
May you continue to achieve greater milestones ahead.</p>

        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/aaryaman-sharma.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A moment of pride as Aaryaman steps onto the global stage—wishing him success, confidence, and many winning innings ahead! </p>

        </div>
      </div>
      
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/International-Taekwondo-League.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Outstanding performance at the International Taekwondo League (10–12 April 2026)! 🥋
Our Sanskar champions showcased skill, discipline, and determination, bringing home an impressive medal tally. </p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Braj.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A proud moment for Sanskar School! ✨
Celebrating excellence as Braj Chaudhary shines with outstanding performance in the Daily Quiz Contest. Keep striving, keep achieving! </p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Zara-Swittens-2.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Diya Sharma shines with a spectacular Double Gold in Mini Master Dressage, while Zara Swittens delivers a stellar six-medal performance—2 Gold, 2 Silver, and 2 Bronze—at the Anand Delhi Horse Show 2026. 🌟

A proud moment for Sanskar as our young equestrians demonstrate grace, discipline, and unmatched determination on a prestigious stage. 💫</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Rahika-Soni.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A moment of pride and history! 🌟
             Radhika Soni of Sanskar School has won a Silver Medal in the U-15 Doubles at the National Championship, contributing to a remarkable comeback for Rajasthan girls in national badminton after over 15 years. 🏸
             Wishing her continued success as she rises higher with every achievement! 💫</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Shaina Khan-2.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A proud moment for Sanskar School! 🌟
Shifan Khan’s dedication and outstanding performance have secured him a place among Rajasthan’s top 4 for the BCCI Under-16 High Performance Camp. Wishing him continued success as he trains with the nation’s finest! 🇮🇳🏏</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/priyakshi-Kaura.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>We are extremely proud to share that Priyakshi Kaura, a student of Class 12 (Humanities) from Sanskar School, has successfully cleared the All India Prelims Entrance Exam 2026 for the prestigious National Institute of Design.
Her dedication, creativity, and hard work have brought great honor to the school. We wish her continued success in the upcoming stages and a bright future ahead!</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/priyakshi-Kaura.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>We are extremely proud to share that Priyakshi Kaura, a student of Class 12 (Humanities) from Sanskar School, has successfully cleared the All India Prelims Entrance Exam 2026 for the prestigious National Institute of Design.
Her dedication, creativity, and hard work have brought great honor to the school. We wish her continued success in the upcoming stages and a bright future ahead!</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Manushree-Saxena.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School proudly celebrates the outstanding achievement of Manushree Saxena of Grade 3D, who has once again recorded her name in the Asia Book of Records as the Youngest 2nd Dan Black Belt in Asia, showcasing remarkable dedication and discipline in martial arts.</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/NSO-Result.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Kudos to the students of class 1-5 for their exceptional achievement in the National Science Olympiad.</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Intach-Filmit.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School was awarded for Maximum Number of Films, along with Best Story (A True Artist – Manasvi Singh), Best Screenplay (Rajputi Virasat – Threads of Royalty – Chitranshi Panwar), Best Narration (Blue Art Pottery – Zynah Danish Ansari), Best Interactive Film (Ghoomar – Harshini Tanwar), and Best Concept (Turning Trash Into Life – Shivraj Singh).</p>

        </div>
      </div>
                          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Radhika-Soni.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Radhika Shines at Jodhpur State Championship 2025–26!
🥇 U-15 Singles (₹3,000) | 🥇 U-17 Singles (₹4,000) | 🥈 U-19 Singles (₹2,000) | 🥇 U-19 Team | 🥇 Women’s Singles (₹6,000) | 🥇 Women’s Team | 🥈 Women’s Doubles (₹1,000) | 🥉 Mixed Doubles (₹500)</p>

        </div>
      </div>


                  <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/VVM.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Aarzoo Sayed of Class XI makes Sanskar School proud by securing 1st Runner-Up at the All-India Home Baker Competition. Talent, passion, and perseverance at their finest!</p>

        </div>
      </div>
                  <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/VVM.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to our young science achievers for making it to the VVM State Camp 2026:
Hitika Dixit (Class 8), Anukriti Moorjani (Class 8), Dhruvika Gaur (Class 8), Khanak Mahavar (Class 8), Gunjan Choudhary (Class 9), and Priyanshi Agarwal (Class 10).
Wishing them continued success as they move forward on their journey of scientific exploration and innovation.

</p>

        </div>
      </div>

                  <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Yogasana-Championship-2025.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to our young science achievers for making it to the VVM State Camp 2026:
Hitika Dixit (Class 8), Anukriti Moorjani (Class 8), Dhruvika Gaur (Class 8), Khanak Mahavar (Class 8), Gunjan Choudhary (Class 9), and Priyanshi Agarwal (Class 10).
Wishing them continued success as they move forward on their journey of scientific exploration and innovation.

</p>

        </div>
      </div>


             <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Yogasana-Championship-2025.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Students of Sanskar School excel at the Roshan Yogasana Foundation competition. Congratulations to Rutveg Singh Shekhawat and Srishti Kanwat for their marvellous achievement.

</p>

        </div>
      </div>
             <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Indo-Nepal-Badminton.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Huge Congratulations to Ms. Priyanshi Sharma, P.E. Teacher at Sanskar School for this outstanding International-level achievement.</p>

        </div>
      </div>
             <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/JNEC-2025.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Diya Sharma makes Jaipur proud with a Silver at the Junior National Equestrian Championship 2025</p>

        </div>
      </div>
             <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/PRATYeK-Inclusive-United-Nations-2025.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to our students for representing the school at the PRATYeK Inclusive United Nations 2025 in Delhi — organised by PRATYeK, NINEISMINE, UNICEF, and Edmund Rice International — a transformative forum empowering young leaders to advance child rights and inclusive futures, under the guidance of Ms. Jaya Dwivedi.</p>

        </div>
      </div>


             <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Junior-Open-Tennis-Championship-2025.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Vihaan Choudhary shines at the Rajasthan State Junior Open Tennis Championship 2025, securing the Runner-Up position in the U-16 Singles category! 🎾🔥
A remarkable achievement at the state level tournament held at Desert Club, Jaisalmer.</p>

        </div>
      </div>



           <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Pan-India-Online-Literature-Competition.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Proud moment for Sanskarians! 🌟 Jinisha Pareek and Vanya Yadav shine bright in the Pan-India Online Literature Competition. 👏
          Congratulations to our young achievers!</p>

        </div>
      </div>



         <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/MMA-Championship-2025.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Champions of Sanskar!
From Gold and Silver triumphs by Anaya Sharma and Padma Jaya Shekhawat to a powerful Bronze victory by Neil Prabhakar, our young MMA athletes showcased exceptional grit and skill at the Indian Open MMA Championship. Proud moments for Team Sanskar! </p>

        </div>
      </div>

       
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Home-Baker-Competition.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>The Home Baker Competition, organised by IIHM and IIPC and held across Pan India in July, saw the participation of over 5,000 talented students from different schools. Among the only five students selected nationwide, Aarzoo Sayed of Class XI has earned her place as one of the top achievers. 🎉✨

Heartiest congratulations to Aarzoo for this remarkable accomplishment! </p>

        </div>
       </div>

        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/School Rankings 2025–26.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Proud Moment for Sanskar School! 🏆

Sanskar School has been ranked among the Top Schools in Rajasthan in the EducationWorld India School Rankings 2025–26 (Co-Ed Day School Category).
The prestigious award was received by Ms. Neelam Bhardwaj and Ms. Girdhar Kumari, Principals of Sanskar School, Jaipur. ✨

A recognition of excellence, dedication, and the Sanskar spirit that continues to inspire! 💫</p>
        </div>
      </div>

        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Team Tejas.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>The Sanskar Shark Tank Competition witnessed brilliant entrepreneurial minds in action! 🏆
In total, 45 teams from Grades IX to XII participated.

✨ Team Tejas (Class XI A) clinched the 1st Rank with their ingenious solar innovation — Tiled Energy Joint & Array System (TEJAS), turning rooftops into sources of clean energy.</p>
        </div>
      </div>

        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/BloomStick.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>The Sanskar Shark Tank Competition witnessed brilliant entrepreneurial minds in action! 🏆
In total, 45 teams from Grades IX to XII participated.


🌸 Team BloomStick (IGCSE Year 2) secured the 2nd Rank for their eco-conscious idea of recycling discarded flowers into natural incense sticks.</p>
        </div>
      </div>

        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/smartbrain.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School Triumphs at IIIM’s “Smart Brain Contest - 2025” Event
Sanskar School once again showcased its brilliance at the Smart Brain Contest organized by IIIM Jaipur. Competing in various categories such as Jugaad to Jhakhas, New Venture Championship, and AI Fusion Code Wizard, our students demonstrated exceptional creativity, innovation, and intellect.

The team of Rahini Koolwal and Aryaman Singh Shekhawat of Grade XI secured 1st position in Jugaad to Jhakhas with their innovative and impactful idea. In the New Venture Championship, Purvi Rajpurohit and Tanmay Gupta of Grade IBDP Year 1 impressed the judges with their entrepreneurial vision, earning the Second Runner-up position.

With outstanding performances across categories, Sanskar School proudly lifted the Overall Championship Trophy, bringing immense pride and glory to the school.</p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Jangjeet Kajal.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Jangjeet Kajal Makes India Proud at the Asian U-17 Badminton Championship

Displaying outstanding skill and determination, Jangjeet Kajal clinched the Bronze Medal in the Asian U-17 Mixed Doubles Championship, held at Chengdu, China, from 21st to 26th October 2025.

His achievement stands as a testament to his perseverance, dedication, and passion for the sport — a true inspiration for young athletes!

✨ Congratulations, Jangjeet, on this remarkable international feat! Your success brings immense pride and joy to the entire Sanskar family!</p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Global & Indian Education Systems.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School – Sirsi Road, Jaipur, was honoured with the 1st Runner-Up Award in the category “Excellence in Integrating Global & Indian Education Systems” at the Vidya Vaibhav International Education Conclave & Awards 2025, held at Ananta Resort & Spa, Udaipur.

The award was received by our esteemed Principals, Ms. Neelam Bhardwaj and Ms. Girdhar Kumari, in recognition of the school’s remarkable efforts in skillfully blending India’s educational wisdom with global best practices to foster an inclusive, future-ready learning culture.</p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Dribbling Towards.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>The Primary Wing of Sanskar School witnessed an action-packed Inter-Class Basketball Competition for Grades 3 to 5, where young players displayed remarkable energy, coordination, and sportsmanship. From thrilling passes to enthusiastic cheers, the court came alive with teamwork and determination — celebrating not just victory, but the joy of the game!</p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Lakshit.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations Lakshit for your exceptional achievement! May you accomplish greater things ahead</p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Kicking High.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Anaya Sharma and Kasvi Malawat from Grade IB shine at the Inter-School Taekwon-Do Championship 2025 with Gold and Silver medals!</p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/French Olympiad 2025.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Students from Grade 4 to IBDP Year 1 of Sanskar School, Jaipur, showcased remarkable linguistic flair at the French Olympiad, organized by Prayatana Educational Society, New Delhi, in association with Alliance Française, Normandie (France) and Bureau du Québec, Mumbai.

A total of 15 students brought laurels to the school by securing Top 3 Ranks at the *Regional Excellence Level* across various categories:

Level A1.1
🥇 Devant Choudhary (4F)
🥈 Jayna Sunil Adnani (5D)
🥉 Yajat Gangwal (5D)

Level A1
🥇 Samarthya Sharma (CP 6)
🥉 Avika Agarwal (6C)

Level A2.1
🥇 Tanush Jangir (7D)
🥉 Shaurya Dravid (7D)

Level A2
🥇 Aaradhya Madhav (CP 8)
🥈 Soumya Tetarwal (CP 8)

🏅 Level B1.1
🥈 Aarzoo Shekhawat (IGCSE Year 1) </p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Taekwondo Championship 2025.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskarites strike gold at the 3rd Bharat National Taekwondo Championship 2025! Celebrating our champions who brought home a rich medal haul through grit and glory. </p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Badminton Tournament!.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Lakshith Rewar for his outstanding performance at the Prakash Padukone Open Badminton Tournament! </p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Shifan Khan.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Shifan Khan (Class XI E) for becoming the youngest member of Rajasthan’s Under-19 Cricket Team and for representing the state in both U-16 and U-19 categories this season!</p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Sanskar racers.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Fuelled by passion, driven by excellence! 
Sanskar racers Yashraj and Dharshil race to 2nd place at the Go Kart Grand Prix 2025 – Inter-School Racing Challenge, held on 27–28 September at Funzo, Jaipur, bringing home the School Trophy with pride and speed!</p>
        </div>
      </div>

        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Sonal Purohit.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Ms. Sonal Purohit of Sanskar School on being honoured with the Wisdom Icon Award for her remarkable contributions and lasting impact in the field of education.</p>
        </div>
      </div>
      
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Karuna.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Ms. Karuna for her remarkable achievement!</p>
        </div>
      </div>
     
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Shuchita Mathur.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Mrs. Shuchita Mathur, an esteemed educator at Sanskar School, received the IIHM Teachers’ Day Award 2025 for her dedication and excellence in education.</p>
        </div>
      </div>
     
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Delisha.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Delisha (Class X B) stood winner at the prestigious “HeART of Biomedicine” competition organized by the University of Melbourne, earning international recognition with her artwork “My World, My Health”, which highlighted the bond between human health and the environment.</p>
        </div>
      </div>
      
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/IIHM Competitions.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School shines at IIHM Competitions Hemlata Bhatt crowned Winner, Rakhshanda Hafeez Khan 1st Runner Up, Shelly Somesh 2nd Runner Up in Teacher’s Chef. </p>
        </div>
      </div>
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/IIHM Competitions 2.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School shines at IIHM Competitions Hemlata Bhatt crowned Winner, Aarzoo Sayed clinched 1st Runner Up in Young Chef. </p>
        </div>
      </div>
    
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Jangjeet Singh.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>From School Courts 🏸 to World Stage 🌍

We are super proud to share that our very own champ Jangjeet Singh Kajla, grade XI, is all set to don the India jersey 🇮🇳 at the Badminton Asia Junior Championships 2025 in China.
From school courts to the international stage—this journey is pure inspiration! ✨✨
👏 Shine bright Jangjeet… your school and nation are behind you!</p>
        </div>
      </div>


        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/brought laurels.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>The young skaters of Sanskar School brought laurels at the 69th SGFI District Level Under-14 Boys/Girls Roller Skating Sports Competition 2025-26, held from 14th to 17th September at Government Upper Primary School, Bandri ka Nashik, Jaipur.</p>
        </div>
      </div>
  

        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Heaven Horse zara.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p> Galloping towards glory! Sanskar School students showcased exceptional talent at the Sapta Shakti Horse Show and Horse Heaven Horse Show 2025, bringing pride to the school with their remarkable performances.</p>
        </div>
      </div>
      
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/house Manvendra Singh.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar Alumnus Manvendra Singh Triumphs at Cornbury House Horse Trials 2025. Manvendra Singh made history as the first Indian rider-horse duo to win on British soil at the Cornbury House Horse Trials 2025.</p>
        </div>
      </div>
  
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Co-Ed Schools.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Celebrating Excellence! 🌟
Sanskar School proudly secures its place among Jaipur’s Top 10 Day Co-Ed Schools with the Cfore School Excellence Award 2025. A proud moment as our Principal, Mrs. Neelam Bhardwaj, received the award, reaffirming our dedication to holistic growth and academic success. </p>
        </div>
      </div>
 
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/West Zone Cricket Tournament.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Out of 620 participants in the under-17 category at the CBSE West Zone Cricket Tournament, Bhopal, 30 players were selected. We are proud that Laxman Singh (Class 11) and Yug Jhajhariya (Class 10) of Sanskar School won Silver medals, bringing glory to the school.
3w </p>
        </div>
      </div>

        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Maitri Agarwal.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Shining bright with knowledge! 🌟 Grade 4 & 5 students Maitri Agarwal and Adhvik Gupta made us proud by bagging the 2nd position in the Quiz at NiNad Inter-School Art & Literary Event* held at Vidhyashram School. </p>
        </div>
      </div>
     
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Anirudh Mayaram Memorial.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School clinched the 19th Anirudh Mayaram Memorial Xavier’s Cup Basketball Tournament with an outstanding performance!</p>
        </div>
      </div>
      
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/TechnoBuzz 2025.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School shines at TechnoBuzz 2025, securing 2nd place with innovative ideas and stellar problem-solving skills!</p>
        </div>
      </div>
       
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/prin.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Ms. Priyanka Sokhal for adding another glorious achievement to her journey!</p>
        </div>
      </div>
     
        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/CBSE Cluster 14.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School Shines at CBSE Cluster 14!
U-17 team emerges as Winners among 77 participating schools, while the U-14 team secures Bronze.
The U-17 champions are now selected to represent at the CBSE Nationals in Rajnandgaon, Chhattisgarh. </p>
        </div>
      </div>



        <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Kanni-Award.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>𝑯𝒐𝒏𝒐𝒖𝒓𝒊𝒏𝒈 𝒕𝒉𝒆 𝒓𝒆𝒎𝒂𝒓𝒌𝒂𝒃𝒍𝒆 𝒍𝒆𝒈𝒂𝒄𝒚 𝒐𝒇 𝑳𝒂𝒕𝒆 𝑴𝒓. 𝑲𝒂𝒏𝒏𝒊 𝑻𝒉𝒂𝒓𝒚𝒂𝒎𝒂𝒍, 𝒇𝒐𝒖𝒏𝒅𝒆𝒓 𝒐𝒇 𝑺𝒂𝒏𝒔𝒌𝒂𝒓 𝑺𝒄𝒉𝒐𝒐𝒍 𝒂𝒏𝒅 𝒂 𝒅𝒆𝒅𝒊𝒄𝒂𝒕𝒆𝒅 𝒍𝒆𝒂𝒅𝒆𝒓 𝒊𝒏 𝒕𝒉𝒆 𝒇𝒊𝒆𝒍𝒅 𝒐𝒇 𝒆𝒅𝒖𝒄𝒂𝒕𝒊𝒐𝒏, 𝑻𝒉𝒆 𝑺𝒄𝒐𝒐𝑵𝒆𝒘𝒔 𝑴𝒆𝒎𝒐𝒓𝒊𝒂𝒍 𝑨𝒘𝒂𝒓𝒅𝒔 2025 𝒉𝒂𝒗𝒆 𝒊𝒏𝒔𝒕𝒊𝒕𝒖𝒕𝒆𝒅 𝒂 𝒑𝒓𝒆𝒔𝒕𝒊𝒈𝒊𝒐𝒖𝒔 𝒏𝒂𝒕𝒊𝒐𝒏𝒂𝒍 𝒂𝒘𝒂𝒓𝒅 𝒊𝒏 𝒉𝒊𝒔 𝒏𝒂𝒎𝒆 — “𝑻𝒉𝒆 𝑲𝒂𝒏𝒏𝒊 𝑻𝒉𝒂𝒓𝒚𝒂𝒎𝒂𝒍 𝑷𝒓𝒊𝒛𝒆 𝒇𝒐𝒓 𝑪𝒉𝒂𝒎𝒑𝒊𝒐𝒏𝒊𝒏𝒈 𝑬𝒅𝒖𝒄𝒂𝒕𝒊𝒐𝒏 𝑨𝒈𝒂𝒊𝒏𝒔𝒕 𝑨𝒍𝒍 𝑶𝒅𝒅𝒔.”</p>
          <p>𝑻𝒉𝒊𝒔 𝒔𝒑𝒆𝒄𝒊𝒂𝒍 𝒓𝒆𝒄𝒐𝒈𝒏𝒊𝒕𝒊𝒐𝒏 𝒊𝒔 𝒂𝒘𝒂𝒓𝒅𝒆𝒅 𝒕𝒐 𝒊𝒏𝒅𝒊𝒗𝒊𝒅𝒖𝒂𝒍𝒔 𝒘𝒉𝒐 𝒆𝒎𝒃𝒐𝒅𝒚 𝒕𝒉𝒆 𝒔𝒂𝒎𝒆 𝒓𝒆𝒔𝒊𝒍𝒊𝒆𝒏𝒄𝒆, 𝒗𝒊𝒔𝒊𝒐𝒏, 𝒂𝒏𝒅 𝒅𝒆𝒆𝒑 𝒄𝒐𝒎𝒎𝒊𝒕𝒎𝒆𝒏𝒕 𝒕𝒐 𝒆𝒅𝒖𝒄𝒂𝒕𝒊𝒐𝒏 𝒕𝒉𝒂𝒕 𝑴𝒓. 𝑻𝒉𝒂𝒓𝒚𝒂𝒎𝒂𝒍 𝒅𝒆𝒎𝒐𝒏𝒔𝒕𝒓𝒂𝒕𝒆𝒅 𝒕𝒉𝒓𝒐𝒖𝒈𝒉𝒐𝒖𝒕 𝒉𝒊𝒔 𝒍𝒊𝒇𝒆. 𝑻𝒉𝒓𝒐𝒖𝒈𝒉 𝒕𝒉𝒊𝒔 𝒉𝒐𝒏𝒐𝒖𝒓, 𝒉𝒊𝒔 𝒍𝒆𝒈𝒂𝒄𝒚 𝒄𝒐𝒏𝒕𝒊𝒏𝒖𝒆𝒔 𝒕𝒐 𝒎𝒐𝒕𝒊𝒗𝒂𝒕𝒆 𝒂𝒏𝒅 𝒈𝒖𝒊𝒅𝒆 𝒆𝒅𝒖𝒄𝒂𝒕𝒐𝒓𝒔 𝒂𝒄𝒓𝒐𝒔𝒔 𝒕𝒉𝒆 𝒄𝒐𝒖𝒏𝒕𝒓𝒚.</p>
          <p>𝑰𝒏 𝒊𝒕𝒔 𝒊𝒏𝒂𝒖𝒈𝒖𝒓𝒂𝒍 𝒚𝒆𝒂𝒓, 𝒕𝒉𝒆 𝒑𝒓𝒊𝒛𝒆 𝒉𝒂𝒔 𝒃𝒆𝒆𝒏 𝒂𝒘𝒂𝒓𝒅𝒆𝒅 𝒕𝒐 𝑴𝒓. 𝑴𝒖𝒌𝒆𝒔𝒉 𝑺𝒉𝒂𝒓𝒎𝒂, 𝑭𝒐𝒖𝒏𝒅𝒆𝒓 𝒂𝒏𝒅 𝑪𝒉𝒂𝒊𝒓𝒑𝒆𝒓𝒔𝒐𝒏 𝒐𝒇 𝑷𝒓𝒐𝒎𝒆𝒕𝒉𝒆𝒖𝒔 𝑺𝒄𝒉𝒐𝒐𝒍, 𝒇𝒐𝒓 𝒉𝒊𝒔 𝒐𝒖𝒕𝒔𝒕𝒂𝒏𝒅𝒊𝒏𝒈 𝒆𝒇𝒇𝒐𝒓𝒕𝒔 𝒊𝒏 𝒂𝒅𝒗𝒂𝒏𝒄𝒊𝒏𝒈 𝒆𝒅𝒖𝒄𝒂𝒕𝒊𝒐𝒏 𝒅𝒆𝒔𝒑𝒊𝒕𝒆 𝒄𝒉𝒂𝒍𝒍𝒆𝒏𝒈𝒆𝒔.</p>
          <p>𝑨 𝒕𝒓𝒖𝒆 𝒕𝒓𝒊𝒃𝒖𝒕𝒆 𝒕𝒐 𝒂 𝒍𝒊𝒇𝒆 𝒔𝒑𝒆𝒏𝒕 𝒃𝒖𝒊𝒍𝒅𝒊𝒏𝒈 𝒂𝒏𝒅 𝒏𝒖𝒓𝒕𝒖𝒓𝒊𝒏𝒈 𝒇𝒖𝒕𝒖𝒓𝒆𝒔, 𝑻𝒉𝒆 𝑲𝒂𝒏𝒏𝒊 𝑻𝒉𝒂𝒓𝒚𝒂𝒎𝒂𝒍 𝑷𝒓𝒊𝒛𝒆 𝒔𝒆𝒓𝒗𝒆𝒔 𝒂𝒔 𝒂 𝒍𝒂𝒔𝒕𝒊𝒏𝒈 𝒓𝒆𝒎𝒊𝒏𝒅𝒆𝒓 𝒐𝒇 𝒉𝒊𝒔 𝒊𝒎𝒑𝒂𝒄𝒕 𝒂𝒏𝒅 𝒄𝒐𝒏𝒕𝒊𝒏𝒖𝒆𝒔 𝒕𝒐 𝒊𝒏𝒔𝒑𝒊𝒓𝒆 𝒆𝒙𝒄𝒆𝒍𝒍𝒆𝒏𝒄𝒆 𝒊𝒏 𝒆𝒅𝒖𝒄𝒂𝒕𝒊𝒐𝒏.</p>
        </div>
      </div>
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Pan-India-Summer.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Future Legal Leaders in the Making! 🌟
Proud of our Legal Studies students for successfully completing their summer internship with Legal Bricks Law Firm, New Delhi.</p>
        </div>
      </div>
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Squash-Championship.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A smashing victory! 🏆👏 Niradhara (6E) secures 1st Position in the Under-11 category at the Subodh Squash Championship 2025.</p>
        </div>
      </div>
       
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Flair-Fest.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Our young Sanskarians showcased their brilliance at Flair Fest with outstanding performances across diverse events. From winning First Prize in Best Out of Waste (Installation/Sculpture Assembling), to securing a Consolation Prize in Collage Making, and rocking the stage as Third Runners-Up in the Rock Band Competition – our students proved their creativity, passion, and teamwork at every step.</p>
        </div>
      </div>
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Ms.-Priyanka-Sokhal.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Ms. Priyanka Sokhal, esteemed educator of Sanskar School, on winning the ‘Best Teacher Award’ by Hindustan Book of Records! 🎉🏆 A talented artist with expertise in multiple mediums, her art brings nature to life.</p>
        </div>
      </div>
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Jangjeet-Kajla.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Smashing Success! 🏸 Sanskar School’s Jangjeet Singh clinches Silver in U-19 Mixed Doubles at the Sri Lanka Junior International Series 2025!</p>
        </div>
      </div>
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/SOF-Olympiads.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>From clinching Gold Medals in SOF Olympiads (Mathematics, Social Science & English) to making a mark in the Spell Bee State Level Competition, our Sanskar stars continue to soar! 🏅
Special applause to:
<p>🔸 Nitika Tripathi – 4th Position</p>
<p>🔸 Namah Sharma – 8th Position</p>
<p>🔸 Rachit Gangwal – Gold | Devanshi Deb – Silver | Ayushman Singh Rathore – Bronze in SOF Hindi Olympiad</p>


</p>
        </div>
      </div>
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/National-Spell-Bee.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>WIZ International Spell Bee – National Mega Final Rank Holders</p>
        </div>
      </div>
               <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Skating-NMS.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A proud moment for Sanskar School at the NMS Cup 2025!
Gold for Yashvardhan Doodi, Yashika Sharma, Hemant Singh & Tejashav Singh✨
Silver for Dhruv Shekhawat 🥈
Bronze for Shikhar Rathore & Manish Godara 🥉
👏 Special applause to Hemant Singh for winning the Best Player Trophy in Skating!
Sanskar School also lifted the Runner-Up Trophy!</p>
        </div>
      </div>

             <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Shlok-Vachan.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Well done, champs!</p>
        </div>
      </div>
          <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/NMS-Cricket.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School clinches the Runner-Up title at the NMS Junior Cricket Cup 2025 – a display of skill, spirit, and sportsmanship!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Abeer-Mirza.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Abeer and Girik for winning 2nd Runner-Up in the Inter-School Fashion Walk!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Harshita-Singh.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Kudos to Harshita Singh (VI C) for winning 🥇Gold in 50m Breast Stroke & 🥈Silver in 50m Back Stroke at the NMS Cup 2025! </p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/ICE-Skating_Hemant.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Hemant Singh Bisht (IX C) clinched two gold medals at the 4th Rajasthan State Ice Skating Championship 2025 in Gurgaon — in the Short Track Race and 500m Race — and has been selected for the National Level. Congratulations and best wishes, Hemant!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/KIO-National-Karate.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Karate Champs in Action – Sanskar students clinch silver and bronze at the 4th KIO National Karate Championship 2025–26!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/NCC-Camp-2025.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Shining Bright at NCC ATC-IX! Proud of our champions Anika Gupta and Aryavardhan Singh Rawat for their stellar victories!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Jayvardhan-Naruka-Karate.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Jayvardhan Naruka on his excellent performance!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/16-Kanni-Trophy.jpg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Champions Again! Sanskar School Clinches 16th Kanni Tharyamal Trophy With a stunning all-round performance, Sanskar School lifts the trophy for the fourth consecutive year, showcasing unmatched skill and team spirit!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/ranvendra-singh.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>A big congratulations to Ranvendra Singh of Grade 1B for securing 6th Rank at the 2024–25 WIZ International Spell Bee – State Level Competition!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Inspire-Manak-Award.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>We’re thrilled to share that Nehal Rathore of Class IX C has been selected for the prestigious INSPIRE MANAK Award by the Department of Science & Technology, Government of India! 🇮🇳✨

Her innovative project “Regreen Robot”, aimed at protecting forest ecosystems using robotics, has earned her a scholarship of ₹10,000 and national recognition. 🌳🔬

Kudos to Nehal for her scientific spirit and dedication—your achievement is an inspiration to all! </p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Shubham-Choudhary.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations, Shubham! 👏
Wishing you good luck as you take the court at the Nationals. Play with passion and make us proud!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/zara-swittens-diya-sharma.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Sanskar School shines at the Anand Delhi Horse Show 2025!
Our young equestrians brought home 9 Gold, 3 Silver, and 5 Bronze medals in Show Jumping and Dressage.✨

👏 Zara Swittens (Grade 9) won the Best Rider Trophy, presented by Defence Secretary Shri Rajesh Kumar.
Kudos to Zara, Diya Sharma (Grade 8), and Yohann Swittens (Grade 4) for their stellar performances!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/NAKSHATRA-SONI.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Congratulations to Nakshatra Soni! Out of 93 participants, he was among the top 5 winners, earning the Best Painting Prize at the Indian Birding Fair! </p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/The-mental-health-and-NEP.png"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Empowering educators for student well-being!
Educators of Sanskar School participated in a workshop on Mental Health and NEP 2020.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/CFoRE School Rankings award.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Ms. Girdhar Kumari, Principal (International Curriculum), Wellbing felicatied with the prestigious CFoRE School Rankings Award.</p> */}
          <p>Ms. Girdhar Kumari, Principal (International Curriculum), well-being felicitated with the prestigious CFoRE School Rankings Award.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Sapta Shakti Horse.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Students of Sanskar School shined at the Sapta Shakti Horse Show in Jaipur, bringing home multiple accolades.</p> */}
          {/* <p>Proudly bringing home multiple accolades Students of Sanskar School Sapta Shakti Horse Show at Sanskar School.</p> */}
          <p>Proudly bringing home multiple accolades, the students of Sanskar School Sapta Shakti Horse Show held at Sanskar School.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/DFest 2024.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>A proud moment for the talented junior dancers on winning first prize in the D’Fest Group Dance category 2024.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/High Happiness Quotient.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Best School under the category of ‘High Happiness Quotient’ in the North School Survey conducted by Education Today</p> */}
          <p>Mrs. Neelam Bhardwaj, Principal (CBSE), was awarded the Best School Award under the category of ‘High Happiness Quotient’ in the North School Survey conducted by Education Today.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Raj bhawan.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Celebrating a proud moment as our Principal along with our talented students met the Honourable Governor of Rajasthan, Kalraj Mishra!</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Aesthetic-School-Awards.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Sanskar School wins the Aesthetic School Awards 2023-24 for ‘Multidisciplinary Experiences’</p> */}
          <p>Ms. Girdhar Kumari, Principal (International Curriculum), was awarded with the  Aesthetic School Awards 2023-24 for ‘Multidisciplinary Experiences.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/Shubham Agarwal UPSC.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Distinguished Sanskar School alumni, Shubham Agarwal, soars to new heights with an impressive rank of 599 in UPSC.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/awe.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Ms. Rhea Tharyamal, Chairperson of Sanskar School, has been honored with the prestigious “AWE” Award for Women Entrepreneurs.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/TYE-Rajasthan-scaled.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>The TYE Rajasthan Chapter Level Competition at Arch College of Design was a showcase of entrepreneurial brilliance by high school students</p> */}
          <p>Talented students of Sanskar School celebrated their win with Mrs. Neelam Bhardwaj, Principal (CBSE), at the TYE Rajasthan Chapter Level Competition at Arch College of Design, recognizing their entrepreneurial brilliance in the high school category.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/District-Taekwondo.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Students of Sanskar School participated in the Open District Taekwondo Championship 2024</p> */}
          <p>Sanskar School students won medals for their outstanding performance at the Open District Taekwondo Championship 2024.</p>
        </div>
      </div>
      
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/67th-State-Educational-Yogasana.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Sanskar School represented Jaipur in ‘Under 19 Girls’ Category at the 67th State Educational Yogasana Tournamen</p> */}
          <p>The Sanskar School Yoga team represented Jaipur in the ‘Under-19 Girls’ category at the 67th State Educational Yogasana Tournament.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/rr.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Sanskar School Cricket team was a part of the recently concluded District Final held at Sanskar Cricket Academy</p> */}
          <p>A proud moment for the Sanskar School Cricket team at the District Final held at Sanskar Cricket Academy.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/exploring-the-essence-of-indian-folk-art-scaled.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar School Commercial Arts students of Grade 11 secured Second Runner Up position in an Inter School Art Competition</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/flair-fest-2023.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar School students proved their mettle once again in Flair Fest Inter-School Competition.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/kaleidoscope.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Were awarded the first position, Sanskar School students secured victory in the Inter-School Fest 'Kaleidoscope'</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/vihaan-radhika.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Backed by their talent, Sanskar School students secured the first position in the Inter-School Fest 'Kaleidoscope'.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/GSLC-INSPIRE 3.0.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Mrs. Neelam Bhardwaj, Principal (CBSE), was the proud recipient of the 'School with Sustainable Infrastructure' award in the event GSLC-INSPIRE 3.0</p> */}
          <p>Mrs. Neelam Bhardwaj, Principal (CBSE), proudly received the 'School 3.0 for Sustainable Infrastructure' award at the GSLC-INSPIRE event</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/14th-kanni-trophy.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar School lifts the 14th Kanni Tharyamal All India Level Inter-School T-20 Cricket Tournament Trophy</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
            <img src="../img/school-achivements/nsa-2022.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          {/* <p>Sanskar School receives National School Award 2022</p> */}
          <p>Sanskar School, recipient of the National School Award 2022.</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
          <img src="../img/student-achivements/Worlds-Youngest-Black-Belt.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
        <p>World’s Youngest Black Belt Manushree Saxena successfully passed her International 2nd DAN NI-DAN Black Belt examination.</p>
        </div>
      </div>



      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
          <img src="../img/student-achivements/Skating-scaled.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
        <p>Tejashav singh Champawat, Hemant Singh Bisht participated in the 67th SGFI U-14 District level Roller Skating Championship 2023.</p>
        </div>
      </div>


      <div className='achivement-box'>
        <div className='achivement-img'>
          <Link to="">
          <img src="../img/student-achivements/puranjay-singh-nirwan.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
        <p>Puranjay Singh Nirwan has achieved All India Rank 22nd in order of merit for the National Defence Academy</p>
        </div>
      </div>
   
  
    </div>


</div>
        </div>
      </div>
    
  );
}

export default Achievements;